<template>
  <div class="column is-6">
    <div class="card">
      <header class="header-card">
        <p> {{ title }} </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline is-vcentered">
          <p class="column is-12 has-text-link">
            {{ info }}
          </p>
          <user-tag-input
            v-model="userSelected"
            @input="setUtilisateursDemandeTempoManuelle"
            :label="$t('societes.fonctionnement.poseOption.utilisateurAValider')"
            :disabled="societe.gestionDemandeTempoManuelle"
            class="column is-10"
          />
          <b-field class="column is-2"
                   :label="$t('societes.fonctionnement.poseOption.tous')">
            <qd-switch v-model="societe.gestionDemandeTempoManuelle"
                      @input="changeGestionDemandeTempoManuelle">
            </qd-switch>
          </b-field>
          <user-tag-input
            v-model="utilisateurSelected"
            @input="setUtilisateursDemandeTempoManuelleAPrevenir"
            :label="$t('societes.fonctionnement.poseOption.utilisateur')"
            class="column is-10"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import userTagInput from '@/components/commun/user/userTagInput';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  components: {
    userTagInput,
  },
  data() {
    return {
      userSelected: [],
      utilisateurSelected: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    interdireModificationBlocageCLGActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key);
    },
    title() {
      return this.interdireModificationBlocageCLGActive
        ? this.$t('societes.fonctionnement.poseOption.titleBlocage') : this.$t('societes.fonctionnement.poseOption.title');
    },
    info() {
      return this.interdireModificationBlocageCLGActive
        ? this.$t('societes.fonctionnement.poseOption.infoBlocage') : this.$t('societes.fonctionnement.poseOption.info');
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    changeGestionDemandeTempoManuelle(valueGestionDemandeTempoManuelle) {
      this.societe.gestionDemandeTempoManuelle = valueGestionDemandeTempoManuelle;
      if (valueGestionDemandeTempoManuelle) {
        this.societe.utilisateursDemandeTempoManuelle = [];
        this.userSelected = [];
      }
    },
    setUtilisateursDemandeTempoManuelleAPrevenir() {
      this.societe.utilisateursDemandeTempoManuelleAPrevenir = this.utilisateurSelected
        .map(u => u.id);
    },
    setUtilisateursDemandeTempoManuelle() {
      this.societe.utilisateursDemandeTempoManuelle = this.userSelected.map(c => c.id);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      this.userSelected = this.users
        .filter(u => this.societe.utilisateursDemandeTempoManuelle.includes(u.id));
      this.utilisateurSelected = this.users
        .filter(u => this.societe.utilisateursDemandeTempoManuelleAPrevenir.includes(u.id));
      await this.loadParametresInterne(
        [PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
